import { Reveal } from "@/components/Reveal";

export const SectionHead = ({ index, label, title, sub, light = false }) => (
    <Reveal className="max-w-3xl">
        <div className="flex items-center gap-3 font-mono text-[11px] uppercase tracking-[0.3em]">
            <span className="text-blaze">{index}</span>
            <span className="h-px w-10 bg-blaze/60" />
            <span className={light ? "text-slate-300" : "text-slate-400"}>{label}</span>
        </div>
        <h2 className="mt-5 font-display text-3xl font-extrabold uppercase leading-[1.02] tracking-tight text-white sm:text-4xl lg:text-5xl">
            {title}
        </h2>
        {sub ? (
            <p className="mt-5 max-w-2xl text-base leading-relaxed text-slate-400 sm:text-lg">
                {sub}
            </p>
        ) : null}
    </Reveal>
);
